import { render, staticRenderFns } from "./HardSoftConsonantsSchoolPreparingPreview.vue?vue&type=template&id=0230e501&lang=pug&"
import script from "./HardSoftConsonantsSchoolPreparingPreview.vue?vue&type=script&lang=js&"
export * from "./HardSoftConsonantsSchoolPreparingPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports